<small class="debug">{{me}}</small>

<!-- Modern Section Header -->
<div class="section-header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <svg width="24px" fill="currentColor" viewBox="0 0 24 24" class="drag-handle">
    <path d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"></path>
    <path d="M0 0h24v24H0z" fill="none"></path>
  </svg>
  <mat-icon class="section-icon">font_download</mat-icon>
  <span class="section-title">
    {{ 'general.fontBrowser' | transloco }}
    <span class="sync-status">({{ fontsPreviewed.length }}/{{ totalFontsToPreview }})</span>
  </span>
  <button mat-icon-button class="close-button" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="font-browser-content">

  <!-- Control Panel -->
  <div class="control-panel">
    <!-- Preview Text Input (hidden on mobile since preview panel is hidden) -->
    <mat-form-field class="preview-text-field" appearance="outline">
      <mat-label>{{ 'general.previewText' | transloco }}</mat-label>
      <input matInput [(ngModel)]="previewText" placeholder="Type text to preview fonts..." autocomplete="off" maxlength="30"/>
      <mat-icon matSuffix>text_fields</mat-icon>
    </mat-form-field>

    <!-- Toolbar -->
    <div class="toolbar">
      <!-- Search -->
      <mat-form-field class="search-field" appearance="outline">
        <mat-label>{{ 'placeholder.filterList' | transloco }}</mat-label>
        <input matInput type="text" (keyup)="applyFilter()" [(ngModel)]="fontFilter" autocomplete="off"/>
        <mat-icon matPrefix>search</mat-icon>
        <button matSuffix mat-icon-button (click)="clearSelection()" *ngIf="fontFilter">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <!-- Favorites Toggle -->
      <button style="position: relative; top: -11px" mat-flat-button class="favorites-toggle" [class.active]="showFavoritesOnly" (click)="toggleShowFavorites()">
        <mat-icon [style.color]="showFavoritesOnly ? '#ffc107' : 'inherit'">star</mat-icon>
        <span>{{ 'general.favorites' | transloco }}</span>
      </button>
    </div>
  </div>

  <!-- Two-Panel Layout -->
  <div class="panels-container">

    <!-- Left Panel: Font List -->
    <div class="font-list-panel">
      <!-- List View -->
      <div class="mat-elevation-z2 list-container">
        <mat-table [dataSource]="dataSource" matSort class="fonts-table">
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>Font Name</mat-header-cell>
            <mat-cell *matCellDef="let row" (click)="onSelectedFontPreview(row)"
                      [class.selected]="row == selectedFont"
                      class="font-cell">
              <div class="font-name-display">
                <div class="font-preview-text" [ngStyle]="{'font-family': row.name, 'font-size': previewFontSize + 'px'}">
                  {{ row.name }}
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="favorite">
            <mat-header-cell *matHeaderCellDef class="favorite-header">
              {{ 'general.favorite' | transloco }}
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="favorite-cell">
              <button mat-icon-button (click)="toggleFavorite(row); $event.stopPropagation()">
                <mat-icon [class.is-favorite]="row.favorite">star</mat-icon>
              </button>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="['name', 'favorite']"></mat-header-row>
          <mat-row *matRowDef="let row; columns: ['name', 'favorite']"></mat-row>
        </mat-table>
      </div>
    </div>

    <!-- Right Panel: Preview Panel -->
    <div class="preview-panel">
      @if (selectedFont) {
        <div class="preview-header">
          <h3>{{ selectedFont.name }}</h3>
          <button mat-stroked-button (click)="toggleFavorite(selectedFont)" class="favorite-btn-large">
<!--            <mat-icon [class.is-favorite]="selectedFont.favorite">star</mat-icon>-->
              add to favorites
          </button>
        </div>

        <div class="preview-sizes">
          @for (size of [14, 18, 24, 32, 48, 64]; track size) {
            <div class="size-sample">
              <span class="size-label-small">{{ size }}px</span>
              <div class="sample-text" [ngStyle]="{'font-family': selectedFont.name, 'font-size': size + 'px'}">
                {{ previewText }}
              </div>
            </div>
          }
        </div>

        <div class="preview-actions">
          <button mat-raised-button color="primary" (click)="onSelectedFont.emit(selectedFont); onClose()">
            <mat-icon>check</mat-icon>
            {{ 'general.selectFont' | transloco }}
          </button>
        </div>
      } @else {
        <div class="no-font-selected">
          <mat-icon>font_download</mat-icon>
          <p>{{ 'ai.noFontSelected' | transloco }}</p>
        </div>
      }
    </div>

  </div>

  <!-- Paginator Footer - spans full width across both panels -->
  <div class="paginator-footer">
    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons (page)="loadPage($event)"></mat-paginator>
  </div>
</div>
